import {Link, useLocation} from "react-router-dom";
import {
    isActiveLink,
    isActiveParentChild,
} from '../../utils/linkActiveChecker';
import mobileMenuData from '../../data/mobileMenuData';
import React from "react";
function  Breadcrumb ({ title = "", meta = "", formation = false }) {
    const location = useLocation();
    const removeBr = (html) => {
        return html.replace(/<br\s*\/?>/g, ' ');
    };
    return (

        <div className="title-outer">
          <ul className="page-breadcrumb">
            <li key={`0activeParentChild`}>
              <Link to="/">Accueil</Link>
            </li>
              {mobileMenuData.map((item) => (
                  item.items && item.items.length > 0 ? (
                      <>
                          {isActiveParentChild(item.items, location.pathname) && <li key={`activeParentChild-${item.id}`}>{item.label}</li>}
                          {item.items.map((subItem) => (
                              location.pathname.includes(subItem.routePath) ?
                                  formation ? (
                                      <>
                                          <li key={`1activeParentChild-${item.id}`}>{item.label}</li>
                                          <li key={`2activeParentChild-${subItem.routePath}`}><Link to={subItem.routePath}>{subItem.name}</Link>
                                          </li>
                                          <li key={`0activeParentChildRemove`}>{removeBr(meta)}</li>
                                      </>
                                  ) : (
                                      <li key={`3activeParentChild-${subItem.routePath}`}>{subItem.name}</li>
                                  )

                                  : null
                          ))}
                      </>
                  ) : (
                      isActiveLink(item.routePath, location.pathname) && <li key={`4activeParentChild-${item.id}`}><Link to="/">{item.label}</Link></li>
                  )
              ))}
          </ul>
        </div>

  );
}

export default Breadcrumb;
